import React from 'react';
import { connect } from 'react-redux';
import { State } from 'store/state';
import { insightsLoadingSelector } from 'store/state/domainData/selectors';
import { Section as SectionEnum } from 'components/navigation/subheader/SectionsNavigation';
import PricesSectionContent from './SectionContentIL';

interface PricesSectionProps {
  isLoading: boolean;
}

const PricesSection: React.FC<PricesSectionProps> = props => {
  const { isLoading } = props;
  if (isLoading) return null;

  return (
    <div data-auto="prices-history" data-scroll-into-view={SectionEnum.PRICES_ESTIMATION}>
      <PricesSectionContent />
    </div>
  );
};

const mapStateToProps = (state: State) => ({
  isLoading: insightsLoadingSelector(state),
});

export default connect(mapStateToProps)(PricesSection);
